module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.29087",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9643",
      "ably-hubspot-js": "static-2.4688",
      "atom": "static-1.5042",
      "conversations-async-data": "static-2.7635",
      "conversations-error-reporting": "static-1.8856",
      "conversations-internal-pub-sub": "static-1.15945",
      "conversations-internal-schema": "static-1.12841",
      "conversations-message-history": "static-1.12585",
      "conversations-test-sdk": "static-1.10474",
      "conversations-visitor-experience-components": "static-1.22450",
      "head-dlb": "static-1.4938",
      "hs-promise-utils": "static-1.5565",
      "hs-test-utils": "static-1.7985",
      "hubspot-dlb": "static-2.1832",
      "HubStyleTokens": "static-2.11436",
      "I18n": "static-7.1615",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2989",
      "jasmine-runner": "static-1.6438",
      "quartz": "static-1.6985",
      "react-dlb": "static-1.78",
      "react-select-plus": "static-1.104",
      "react-transition-group": "static-2.64",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4446",
      "StyleGuideUI": "static-3.486",
      "transmute": "static-2.85",
      "urlinator": "static-1.4504",
      "usage-tracker": "static-1.7316",
      "usage-tracker-core": "static-1.7166",
      "usage-tracker-public": "static-1.7127",
      "viral-links-lib": "static-1.7027",
      "visitor-ui-component-library": "static-1.6109",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4782",
      "conversations-prop-types": "static-1.7422",
      "conversations-visitor-message-history": "static-1.21187",
      "cssUtils": "static-1.782",
      "enviro": "static-4.428",
      "flux-actions": "static-1.331",
      "foundations-components": "static-1.7868",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6193",
      "hubspot-url-utils": "static-1.4049",
      "immutable": "static-2.77",
      "metrics-js": "static-1.9542",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.388",
      "raven": "static-3.5829",
      "react": "static-7.185",
      "react-aria": "static-1.65",
      "react-dom": "static-7.85",
      "react-redux": "static-7.70",
      "react-rhumb": "static-1.16640",
      "react-utils": "static-2.5319",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8113",
      "signup-constants": "static-1.18786",
      "styled-components": "static-2.88",
      "usage-tracker-multi": "static-1.5730",
      "visitor-ui-component-library-icons": "static-1.5920",
      "hs-promise-rejection-tracking": "static-1.5489",
      "raven-hubspot": "static-1.6136",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3378",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.85",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.81",
      "quartz-config": "static-1.763",
      "quartz-core": "static-1.6204",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4833",
      "foundations-theming": "static-1.4388",
      "UIComponents": "static-3.8383",
      "customer-data-email": "static-1.17977",
      "cv-backend-services": "static-1.1552",
      "immutable-less": "static-1.4623",
      "conversations-skeleton-state": "static-1.7219",
      "crm-events-viz-core": "static-1.33091",
      "customer-data-objects": "static-1.7633",
      "icons": "static-2.644",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4622",
      "ui-images": "static-2.1143",
      "HeadJS": "static-2.745",
      "framer-motion": "static-1.71",
      "hs-test-utils-bend-plugin": "static-1.3096",
      "msw": "static-1.39",
      "testing-library": "static-1.151",
      "i18n-data": "static-1.220",
      "moment-timezone": "static-5.82",
      "jasmine": "static-4.4297",
      "signup-ui-url-generator": "static-2.8011",
      "HubStyle": "static-2.11744",
      "quartz-i18n": "static-1.660",
      "sassPrefix": "static-1.155",
      "bend-plugin-foundations-components": "static-1.4137",
      "floating-ui": "static-1.55",
      "foundations-theming-specialty": "static-1.2104",
      "hs-story-utils": "static-1.9399",
      "react-create-root-preference": "static-1.13",
      "react-virtualized": "static-2.98",
      "tanstack-table": "static-1.54",
      "trellis-assets": "static-1.1769",
      "ui-fonts": "static-1.698",
      "hs-locale-management": "static-1.60",
      "csstype": "static-1.50",
      "quartz-head": "static-1.650",
      "quick-fetch": "static-1.3891",
      "web-vitals": "static-1.4",
      "quartz-routing": "static-1.415",
      "usage-tracker-anonymous": "static-1.5733",
      "bender-build-tools": "static-1.3160",
      "dispatcher": "static-1.135",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.828",
      "hubspotter-http": "static-1.4627",
      "mobile-manifest-mixins": "static-1.519",
      "module-federation": "static-1.22",
      "quartz-auth": "static-1.660",
      "quartz-test": "static-1.660",
      "quartz-tracking": "static-1.364",
      "usage-tracker-container": "static-1.7306",
      "bend-plugin-foundations-theming": "static-1.2871",
      "foundations-theming-base": "static-1.3373",
      "stylex": "static-1.32",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4620",
      "customer-data-ui-utilities": "static-1.9797",
      "FileManagerCore": "static-1.39028",
      "FileManagerLib": "static-1.39169",
      "hubspot-apollo-client": "static-1.4848",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.524",
      "timezone-utils": "static-2.5215",
      "ui-gdpr-components": "static-1.10318",
      "ts-schema": "static-1.4053",
      "ai-components-ui-library": "static-1.8859",
      "avatar-components": "static-1.2469",
      "content-assistance-lib": "static-1.7703",
      "crm-component-utils": "static-1.38999",
      "crm-display-components": "static-1.24749",
      "crm-fe-perf": "static-1.22874",
      "crm-links": "static-1.6256",
      "crm-message-bus": "static-1.42906",
      "crm-search-service-types": "static-1.1123",
      "crm-source-interpretation-lib": "static-1.5310",
      "customer-data-communicator": "static-1.45452",
      "customer-data-filters-ui": "static-1.39645",
      "customer-data-objects-ui-components": "static-1.12996",
      "customer-data-properties": "static-1.51433",
      "customer-data-rte": "static-1.32909",
      "draft-plugins": "static-2.21617",
      "file-manager-components": "static-1.23529",
      "framework-data-schema-resolvers": "static-1.6852",
      "frontend-preferences-client": "static-1.7900",
      "hubspot-prosemirror": "static-1.18155",
      "object-comments-thread-lib": "static-1.10564",
      "prosemirror-user-and-team-at-mentions": "static-1.520",
      "reference-resolvers-lite": "static-1.8066",
      "ui-addon-upgrades": "static-9.17940",
      "universal-associations-select": "static-1.10998",
      "universal-record-utils-lib": "static-1.794",
      "wootric-nps": "static-1.6953",
      "inbound-db-properties-service-client": "static-1.3818",
      "property-translator": "static-1.5372",
      "bend-plugin-chirp-manifest": "static-1.32",
      "chirp-fetch": "static-1.1858",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "hub-http-shared-msw-handlers": "static-1.9886",
      "hubspotter-http-shared-msw-handlers": "static-1.9884",
      "usage-tracker-session-replay": "static-1.5002",
      "react-dnd-compat": "static-1.4591",
      "audio-components": "static-1.5868",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29238",
      "FileManagerImages": "static-1.36680",
      "foundations-components-legacy": "static-1.893",
      "immerable": "static-1.4125",
      "ui-universal-auth": "static-1.8941",
      "video-components": "static-1.13171",
      "video-data-lib": "static-1.34826",
      "video-embed": "static-1.35660",
      "hubspot-apollo-cache": "static-1.307",
      "chatspot-core": "static-1.21142",
      "ContentUtils": "static-1.68268",
      "copilot-toolkit": "static-1.11052",
      "superstore": "static-1.4736",
      "ui-addon-video-player": "static-1.8671",
      "ui-coaching-tips": "static-1.28461",
      "card-properties-lib": "static-1.44082",
      "commerce-subscription-lib": "static-1.37015",
      "crm-actions": "static-1.6292",
      "crm-cards-sdk": "static-1.43491",
      "customer-data-properties-shared-msw-handlers": "static-1.9213",
      "customer-data-property-utils": "static-1.8056",
      "customer-data-tracking": "static-1.6856",
      "hs-resources": "static-1.123",
      "inbound-db-meta-service-client": "static-1.3565",
      "pulse": "static-1.535",
      "framework-data-table": "static-2.11842",
      "location-customization-utils-lib": "static-1.9157",
      "calling-error-reporting": "static-1.31280",
      "calling-internal-common": "static-1.31274",
      "calling-usage-tracker": "static-1.6514",
      "crm_data": "static-4.91860",
      "customer-data-content": "static-1.27219",
      "draft-content-plugins": "static-1.28177",
      "draft-convert": "static-2.72",
      "draft-extend": "static-3.74",
      "draft-js": "static-5.77",
      "draft-signature-plugin": "static-1.23980",
      "EmailSignatureEditor": "static-1.24301",
      "hubspot-prosemirror-plugins": "static-1.18147",
      "integration-settings-components": "static-1.15389",
      "integrations-lib": "static-1.16017",
      "integrations-tracking-lib": "static-1.5570",
      "native-integrations-shared-strings": "static-1.7753",
      "nav-meta": "static-1.29571",
      "onboarding-scopes": "static-1.6433",
      "outreach-assistant-email-generation": "static-1.6142",
      "prosemirror-copilot": "static-1.11539",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37986",
      "react-colorpicker": "static-2.10181",
      "reference-resolvers": "static-1.8140",
      "rich-text-lib": "static-1.19775",
      "sales-email-signature-service-client": "static-1.3814",
      "sequences-lib": "static-1.7985",
      "ui-addon-i18n": "static-1.11121",
      "ui-addon-iframeable": "static-1.9028",
      "ui-business-units-lib": "static-1.9020",
      "ui-shepherd-react": "static-3.10125",
      "user-context": "static-1.5073",
      "whatsapp-sending-lib": "static-1.5586",
      "customer-data-filters-ui-msw-helpers": "static-1.22080",
      "customer-data-reference-ui-components": "static-1.13130",
      "FormUrlGenerator": "static-2.4689",
      "framework-builder-read-service-client": "static-1.3984",
      "framework-data-schema-quick-fetch": "static-1.6757",
      "multi-account-reference-resolvers": "static-1.949",
      "onboarding-tours": "static-1.16539",
      "reporting-datasets-permissions-lib": "static-1.13588",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21503",
      "calling-global-api": "static-1.64409",
      "calling-lifecycle-internal": "static-1.65791",
      "calling-lifecycle-messages": "static-1.58085",
      "commerce-products-lib": "static-1.9437",
      "conditional-properties-service-client": "static-1.3772",
      "external-options-client-types": "static-1.4133",
      "google-libphonenumber": "static-1.37",
      "inbounddb-objects-service-types": "static-1.4198",
      "meetings-icalendar-utils-lib": "static-1.603",
      "multi-currency-client-types": "static-1.3666",
      "object-builder-ui-client": "static-1.48630",
      "pipeline-validation-client-types": "static-1.3940",
      "property-value-citations": "static-1.2047",
      "smart-property-lib": "static-1.6761",
      "tiered-pricing": "static-1.1134",
      "ui-addon-form-validation": "static-1.10961",
      "video-components-external": "static-1.11168",
      "batch-promise": "static-1.1513",
      "crm-pipelines-api-client-types": "static-1.4117",
      "persist-promise": "static-1.3670",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25282",
      "knowledge-content-types": "static-1.8483",
      "payment-link-components": "static-1.23447",
      "ui-addon-emoji-picker": "static-1.9858",
      "call-summary": "static-1.39099",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10032",
      "laboratory-lib": "static-3.7130",
      "merchandise-lib": "static-1.262",
      "purchase-motions-components": "static-1.5825",
      "crm-object-search-query-utilities": "static-1.9503",
      "amplitude-session-replay-browser": "static-1.59",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.736",
      "content-icons-ui": "static-1.2216",
      "social-insights-client-types": "static-1.22006",
      "outpost": "static-1.4156",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4783",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5536",
      "magpie-types": "static-1.4996",
      "simple-logging-lib": "static-1.3020",
      "growth-onboarding-feedback-components": "static-1.6553",
      "customer-data-sidebar": "static-2.45922",
      "enrichment-properties-lib": "static-1.15879",
      "commerce-billing-lib": "static-1.18975",
      "commerce-shared-components-lib": "static-1.18440",
      "commerce-tools-ui-lib": "static-1.10286",
      "bend-plugin-pulse": "static-1.38",
      "directed-graph": "static-1.906",
      "event-emitter": "static-1.919",
      "fast-json-patch": "static-1.62",
      "customer-data-associations": "static-1.7295",
      "deal-intel-decorators": "static-1.1878",
      "reporting-data": "static-1.67402",
      "tanstack-virtual": "static-1.29",
      "ui-addon-draggable": "static-3.4739",
      "crm-record-cards-service-types": "static-1.3583",
      "self-service-api": "static-1.10216",
      "crm_universal": "static-1.21950",
      "SalesContentIndexUI": "static-3.9195",
      "content-embed-lib": "static-1.7310",
      "data-model-builder-lib": "static-1.12228",
      "remote-ui": "static-1.64",
      "ui-components-test-utils": "static-1.5574",
      "ui-extensions-remote-renderer": "static-1.16914",
      "universal-page-editor-lib": "static-1.2984",
      "integrations-error-boundary-lib": "static-1.13432",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10341",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.455",
      "messaging-types-lib": "static-1.45913",
      "ai-addon-copilot-preview": "static-1.8071",
      "copilot-plugins": "static-1.11025",
      "data-token-picker": "static-1.16351",
      "sequences-client-types-lib": "static-1.7842",
      "foundations-components-test-utils": "static-1.5351",
      "navigation-messaging": "static-1.7261",
      "getting-started-shared-tasks": "static-1.18415",
      "getting-started-shared-tasks-store": "static-1.17533",
      "onboarding-tours-utils": "static-1.605",
      "messaging-usage-based-billing-components-lib": "static-1.1038",
      "whatsapp-management-lib": "static-1.8745",
      "growth-data-modal": "static-1.5379",
      "growth-onboarding-confetti": "static-1.3038",
      "growth-onboarding-next-action-utils": "static-1.1831",
      "navigation-components": "static-1.17934",
      "onboarding-tours-client": "static-1.4753",
      "ui-shepherd-tracker": "static-1.7506",
      "shared-worker-versioning": "static-1.11009",
      "voice-sms-access-library": "static-1.854",
      "commerce-permissions": "static-1.737",
      "products-iframe-lib": "static-1.7844",
      "products-ui-components-shared-msw-handlers": "static-1.10268",
      "data-agent-kit": "static-1.144",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9969",
      "fsm": "static-1.3702",
      "policy-lib": "static-1.6747",
      "react-tinymce": "static-1.55149",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54275",
      "tinymce-plugins": "static-1.57389",
      "tinymce-themes": "static-1.56245",
      "content-media-composition-data-lib": "static-1.12154",
      "content-media-compositions": "static-2.16161",
      "idb-keyval": "static-1.43",
      "media-bridge-lib": "static-1.18871",
      "ui-addon-opt": "static-4.8341",
      "commerce-tours-lib": "static-1.6033",
      "growth-onboarding-reliability": "static-1.5054",
      "sales-checkout-service-client": "static-1.3610",
      "calling-cross-tab-library": "static-1.19254",
      "calling-lifecycle-usage-tracker": "static-1.8615",
      "purchase-motions-api": "static-1.5828",
      "trials-service-types": "static-1.3874",
      "reactive-lib": "static-1.693",
      "card-payment-highlight-lib": "static-1.37075",
      "card-subscription-highlight-lib": "static-1.39438",
      "commerce-contract-lib": "static-1.11927",
      "invoices-highlight-card-lib": "static-1.54618",
      "orders-highlight-card-lib": "static-1.21383",
      "products-highlight-card-lib": "static-1.17721",
      "quotes-highlight-card-lib": "static-1.71896",
      "usage-based-billing-components-lib": "static-1.8719",
      "utility-belt": "static-1.2508",
      "payments-enrollment-embed-lib": "static-1.22668",
      "stripe-embedded-components": "static-1.7447",
      "growth-onboarding-empty-states": "static-1.5661",
      "InboxConnectUtils": "static-4.14725",
      "payments-post-enroll-local-storage-lib": "static-1.5080",
      "qrcode-generator": "static-1.68",
      "deal-intel-utils": "static-1.1882",
      "storybook-react": "static-1.32",
      "reporting-client-types": "static-1.2488",
      "react-flip-move": "static-1.69",
      "FireAlarmUi": "static-1.4487",
      "sales-templates-service-types-lib": "static-1.4143",
      "ui-asset-management-lib": "static-1.10981",
      "association-settings-lib": "static-1.10190",
      "collaboration-sidebar": "static-1.57704",
      "conditional-property-settings-modal": "static-1.12384",
      "data-model-commons-lib": "static-1.12498",
      "final-form": "static-1.69",
      "html-to-image": "static-1.53",
      "nudge-client-utils": "static-1.2499",
      "object-definition-builder-lib": "static-1.7062",
      "property-management-iframe": "static-1.13038",
      "property-usages-lib": "static-1.5398",
      "reactflow": "static-1.63",
      "simple-data-table": "static-1.2687",
      "used-in-list-lib": "static-1.6917",
      "visual-association": "static-1.5845",
      "highcharts": "static-8.103",
      "reporting-visualizations": "static-1.59478",
      "ui-extensibility-client-types": "static-1.3899",
      "google-sheets-integration-lib": "static-1.143",
      "microsoft-drive-integration-lib": "static-1.260",
      "automation-platform-service-types": "static-1.2575",
      "ContentData": "static-1.68343",
      "email-portal-health-service-types": "static-1.947",
      "marketing-email-service-types": "static-1.1898",
      "ai-rendering-library": "static-1.10017",
      "ai-settings-ui-library": "static-1.7835",
      "ui-brand-identity-lib": "static-1.15132",
      "messaging-shared-utils-lib": "static-1.487",
      "messaging-user-info-utils-lib": "static-1.657",
      "content-whatsapp-service-types": "static-1.376",
      "marketing-platform-lib": "static-1.6823",
      "short-messages-app-service-client": "static-1.3949",
      "ui-tool-access": "static-1.10121",
      "onboarding-data-sync-lib": "static-1.1908",
      "growth-onboarding-next-action-components": "static-1.1859",
      "user-context-client": "static-1.4583",
      "nest": "static-1.196",
      "calling-orchestration-schema": "static-1.35631",
      "sales-views-client-types": "static-1.4235",
      "trellis-story-utils": "static-1.4487",
      "hub-http-contrib": "static-1.3010",
      "interframe": "static-3.4731",
      "tinymce-data": "static-1.40360",
      "ui-addon-sales-email": "static-1.5181",
      "codemirror": "static-5.94",
      "layout-dnd-components": "static-1.12383",
      "layout-dnd-utils": "static-1.11358",
      "react-codemirror": "static-1.10596",
      "NamespacedHubStyle": "static-2.9036",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.39956",
      "zustand": "static-1.74",
      "accounting-integrations-ui-components": "static-1.7013",
      "invoices-ui-lib": "static-1.54634",
      "commerce-products-api": "static-1.2239",
      "invoices-iframe-lib": "static-1.56692",
      "quotes-modal-lib": "static-1.102574",
      "quotes-ui-lib": "static-1.80617",
      "platform-infra-nav-components": "static-1.7648",
      "reporting-ui-components": "static-2.64673",
      "subscription-experience-data-types": "static-1.14886",
      "marketplace-ui-apps-core": "static-1.18136",
      "stripe-connect-js": "static-1.68",
      "ui-addon-react-router-dom": "static-1.9515",
      "nested-table": "static-1.196",
      "chatspot-widget-iframe": "static-1.21133",
      "collaboration-sidebar-common": "static-1.2501",
      "crm-properties-common-lib": "static-1.5850",
      "ui-addon-draggable-compat": "static-2.4226",
      "nudge-custom-function-registry": "static-1.2256",
      "nudge-renderer-utils": "static-1.2575",
      "whisper-core-api": "static-1.6530",
      "property-management-common": "static-1.5326",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15082",
      "advanced-menus-lib": "static-1.12028",
      "ExportDialog": "static-6.10364",
      "ui-memberships-settings-lib": "static-1.33959",
      "embedded-academy-lib": "static-1.14241",
      "highlight.js": "static-1.78",
      "reporting-action-components": "static-1.41215",
      "reporting-snowflake": "static-1.56020",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9683",
      "browser-eslint": "static-2.57",
      "commerce-tax-lib": "static-1.495",
      "price-books-api": "static-1.545",
      "price-books-components": "static-1.603",
      "property-description-translator": "static-1.3817",
      "ramp-editor": "static-1.68",
      "commerce-analytics-service-client": "static-1.3598",
      "totals-ui-components": "static-1.23506",
      "reporting-plugins": "static-1.10269",
      "reporting-reports": "static-1.67080",
      "edison-service-client-types": "static-1.358",
      "developer-experience-shared-components": "static-1.10481",
      "marketplace-ui-client-types": "static-1.17010",
      "marketplace-ui-common": "static-1.19603",
      "ui-addon-integrations-directory-panel": "static-2.7967",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.144",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15081",
      "simple-menus-lib": "static-1.16598",
      "academy-common-lib": "static-1.13701",
      "dashboard-lib": "static-1.81388",
      "share-with-third-party-component-lib": "static-1.8672",
      "line-items-api": "static-1.640",
      "commerce-totals-service-types": "static-1.3793",
      "campaign-roi-lib": "static-1.9001",
      "apps-service-types": "static-1.3848",
      "oauth-service-types": "static-1.4221",
      "academy-service-client": "static-1.3653",
      "croppie": "static-2.10",
      "trellis-ecosystem": "static-1.7076",
      "redux-actions": "static-3.7",
      "breeze-engine-lib": "static-1.510"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.29087",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9643",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4688",
      "atom": "/atom/static-1.5042",
      "conversations-async-data": "/conversations-async-data/static-2.7635",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8856",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15945",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12841",
      "conversations-message-history": "/conversations-message-history/static-1.12585",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10474",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.22450",
      "head-dlb": "/head-dlb/static-1.4938",
      "hs-promise-utils": "/hs-promise-utils/static-1.5565",
      "hs-test-utils": "/hs-test-utils/static-1.7985",
      "hubspot-dlb": "/hubspot-dlb/static-2.1832",
      "HubStyleTokens": "/HubStyleTokens/static-2.11436",
      "I18n": "/I18n/static-7.1615",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2989",
      "jasmine-runner": "/jasmine-runner/static-1.6438",
      "quartz": "/quartz/static-1.6985",
      "react-dlb": "/react-dlb/static-1.78",
      "react-select-plus": "/react-select-plus/static-1.104",
      "react-transition-group": "/react-transition-group/static-2.64",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4446",
      "StyleGuideUI": "/StyleGuideUI/static-3.486",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4504",
      "usage-tracker": "/usage-tracker/static-1.7316",
      "usage-tracker-core": "/usage-tracker-core/static-1.7166",
      "usage-tracker-public": "/usage-tracker-public/static-1.7127",
      "viral-links-lib": "/viral-links-lib/static-1.7027",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6109",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4782",
      "conversations-prop-types": "/conversations-prop-types/static-1.7422",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.21187",
      "cssUtils": "/cssUtils/static-1.782",
      "enviro": "/enviro/static-4.428",
      "flux-actions": "/flux-actions/static-1.331",
      "foundations-components": "/foundations-components/static-1.7868",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6193",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
      "immutable": "/immutable/static-2.77",
      "metrics-js": "/metrics-js/static-1.9542",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.388",
      "raven": "/raven/static-3.5829",
      "react": "/react/static-7.185",
      "react-aria": "/react-aria/static-1.65",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.70",
      "react-rhumb": "/react-rhumb/static-1.16640",
      "react-utils": "/react-utils/static-2.5319",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8113",
      "signup-constants": "/signup-constants/static-1.18786",
      "styled-components": "/styled-components/static-2.88",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5730",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5920",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
      "raven-hubspot": "/raven-hubspot/static-1.6136",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3378",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.81",
      "quartz-config": "/quartz-config/static-1.763",
      "quartz-core": "/quartz-core/static-1.6204",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4833",
      "foundations-theming": "/foundations-theming/static-1.4388",
      "UIComponents": "/UIComponents/static-3.8383",
      "customer-data-email": "/customer-data-email/static-1.17977",
      "cv-backend-services": "/cv-backend-services/static-1.1552",
      "immutable-less": "/immutable-less/static-1.4623",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7219",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33091",
      "customer-data-objects": "/customer-data-objects/static-1.7633",
      "icons": "/icons/static-2.644",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4622",
      "ui-images": "/ui-images/static-2.1143",
      "HeadJS": "/HeadJS/static-2.745",
      "framer-motion": "/framer-motion/static-1.71",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3096",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.151",
      "i18n-data": "/i18n-data/static-1.220",
      "moment-timezone": "/moment-timezone/static-5.82",
      "jasmine": "/jasmine/static-4.4297",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8011",
      "HubStyle": "/HubStyle/static-2.11744",
      "quartz-i18n": "/quartz-i18n/static-1.660",
      "sassPrefix": "/sassPrefix/static-1.155",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4137",
      "floating-ui": "/floating-ui/static-1.55",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2104",
      "hs-story-utils": "/hs-story-utils/static-1.9399",
      "react-create-root-preference": "/react-create-root-preference/static-1.13",
      "react-virtualized": "/react-virtualized/static-2.98",
      "tanstack-table": "/tanstack-table/static-1.54",
      "trellis-assets": "/trellis-assets/static-1.1769",
      "ui-fonts": "/ui-fonts/static-1.698",
      "hs-locale-management": "/hs-locale-management/static-1.60",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.650",
      "quick-fetch": "/quick-fetch/static-1.3891",
      "web-vitals": "/web-vitals/static-1.4",
      "quartz-routing": "/quartz-routing/static-1.415",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5733",
      "bender-build-tools": "/bender-build-tools/static-1.3160",
      "dispatcher": "/dispatcher/static-1.135",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.828",
      "hubspotter-http": "/hubspotter-http/static-1.4627",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.519",
      "module-federation": "/module-federation/static-1.22",
      "quartz-auth": "/quartz-auth/static-1.660",
      "quartz-test": "/quartz-test/static-1.660",
      "quartz-tracking": "/quartz-tracking/static-1.364",
      "usage-tracker-container": "/usage-tracker-container/static-1.7306",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2871",
      "foundations-theming-base": "/foundations-theming-base/static-1.3373",
      "stylex": "/stylex/static-1.32",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4620",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9797",
      "FileManagerCore": "/FileManagerCore/static-1.39028",
      "FileManagerLib": "/FileManagerLib/static-1.39169",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4848",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.524",
      "timezone-utils": "/timezone-utils/static-2.5215",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10318",
      "ts-schema": "/ts-schema/static-1.4053",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8859",
      "avatar-components": "/avatar-components/static-1.2469",
      "content-assistance-lib": "/content-assistance-lib/static-1.7703",
      "crm-component-utils": "/crm-component-utils/static-1.38999",
      "crm-display-components": "/crm-display-components/static-1.24749",
      "crm-fe-perf": "/crm-fe-perf/static-1.22874",
      "crm-links": "/crm-links/static-1.6256",
      "crm-message-bus": "/crm-message-bus/static-1.42906",
      "crm-search-service-types": "/crm-search-service-types/static-1.1123",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5310",
      "customer-data-communicator": "/customer-data-communicator/static-1.45452",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39645",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12996",
      "customer-data-properties": "/customer-data-properties/static-1.51433",
      "customer-data-rte": "/customer-data-rte/static-1.32909",
      "draft-plugins": "/draft-plugins/static-2.21617",
      "file-manager-components": "/file-manager-components/static-1.23529",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6852",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7900",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18155",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10564",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.520",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8066",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17940",
      "universal-associations-select": "/universal-associations-select/static-1.10998",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.794",
      "wootric-nps": "/wootric-nps/static-1.6953",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3818",
      "property-translator": "/property-translator/static-1.5372",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.32",
      "chirp-fetch": "/chirp-fetch/static-1.1858",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9886",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9884",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5002",
      "react-dnd-compat": "/react-dnd-compat/static-1.4591",
      "audio-components": "/audio-components/static-1.5868",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29238",
      "FileManagerImages": "/FileManagerImages/static-1.36680",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.893",
      "immerable": "/immerable/static-1.4125",
      "ui-universal-auth": "/ui-universal-auth/static-1.8941",
      "video-components": "/video-components/static-1.13171",
      "video-data-lib": "/video-data-lib/static-1.34826",
      "video-embed": "/video-embed/static-1.35660",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.307",
      "chatspot-core": "/chatspot-core/static-1.21142",
      "ContentUtils": "/ContentUtils/static-1.68268",
      "copilot-toolkit": "/copilot-toolkit/static-1.11052",
      "superstore": "/superstore/static-1.4736",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8671",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28461",
      "card-properties-lib": "/card-properties-lib/static-1.44082",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37015",
      "crm-actions": "/crm-actions/static-1.6292",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43491",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9213",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8056",
      "customer-data-tracking": "/customer-data-tracking/static-1.6856",
      "hs-resources": "/hs-resources/static-1.123",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3565",
      "pulse": "/pulse/static-1.535",
      "framework-data-table": "/framework-data-table/static-2.11842",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9157",
      "calling-error-reporting": "/calling-error-reporting/static-1.31280",
      "calling-internal-common": "/calling-internal-common/static-1.31274",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6514",
      "crm_data": "/crm_data/static-4.91860",
      "customer-data-content": "/customer-data-content/static-1.27219",
      "draft-content-plugins": "/draft-content-plugins/static-1.28177",
      "draft-convert": "/draft-convert/static-2.72",
      "draft-extend": "/draft-extend/static-3.74",
      "draft-js": "/draft-js/static-5.77",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23980",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24301",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18147",
      "integration-settings-components": "/integration-settings-components/static-1.15389",
      "integrations-lib": "/integrations-lib/static-1.16017",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5570",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7753",
      "nav-meta": "/nav-meta/static-1.29571",
      "onboarding-scopes": "/onboarding-scopes/static-1.6433",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6142",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.11539",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37986",
      "react-colorpicker": "/react-colorpicker/static-2.10181",
      "reference-resolvers": "/reference-resolvers/static-1.8140",
      "rich-text-lib": "/rich-text-lib/static-1.19775",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3814",
      "sequences-lib": "/sequences-lib/static-1.7985",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11121",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9028",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9020",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10125",
      "user-context": "/user-context/static-1.5073",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5586",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22080",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13130",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4689",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3984",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6757",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.949",
      "onboarding-tours": "/onboarding-tours/static-1.16539",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13588",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21503",
      "calling-global-api": "/calling-global-api/static-1.64409",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65791",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58085",
      "commerce-products-lib": "/commerce-products-lib/static-1.9437",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3772",
      "external-options-client-types": "/external-options-client-types/static-1.4133",
      "google-libphonenumber": "/google-libphonenumber/static-1.37",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4198",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.603",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3666",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48630",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3940",
      "property-value-citations": "/property-value-citations/static-1.2047",
      "smart-property-lib": "/smart-property-lib/static-1.6761",
      "tiered-pricing": "/tiered-pricing/static-1.1134",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10961",
      "video-components-external": "/video-components-external/static-1.11168",
      "batch-promise": "/batch-promise/static-1.1513",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4117",
      "persist-promise": "/persist-promise/static-1.3670",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25282",
      "knowledge-content-types": "/knowledge-content-types/static-1.8483",
      "payment-link-components": "/payment-link-components/static-1.23447",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9858",
      "call-summary": "/call-summary/static-1.39099",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10032",
      "laboratory-lib": "/laboratory-lib/static-3.7130",
      "merchandise-lib": "/merchandise-lib/static-1.262",
      "purchase-motions-components": "/purchase-motions-components/static-1.5825",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9503",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.736",
      "content-icons-ui": "/content-icons-ui/static-1.2216",
      "social-insights-client-types": "/social-insights-client-types/static-1.22006",
      "outpost": "/outpost/static-1.4156",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4783",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5536",
      "magpie-types": "/magpie-types/static-1.4996",
      "simple-logging-lib": "/simple-logging-lib/static-1.3020",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6553",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45922",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15879",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18975",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18440",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10286",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.38",
      "directed-graph": "/directed-graph/static-1.906",
      "event-emitter": "/event-emitter/static-1.919",
      "fast-json-patch": "/fast-json-patch/static-1.62",
      "customer-data-associations": "/customer-data-associations/static-1.7295",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1878",
      "reporting-data": "/reporting-data/static-1.67402",
      "tanstack-virtual": "/tanstack-virtual/static-1.29",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4739",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3583",
      "self-service-api": "/self-service-api/static-1.10216",
      "crm_universal": "/crm_universal/static-1.21950",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9195",
      "content-embed-lib": "/content-embed-lib/static-1.7310",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12228",
      "remote-ui": "/remote-ui/static-1.64",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5574",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16914",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2984",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13432",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10341",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.455",
      "messaging-types-lib": "/messaging-types-lib/static-1.45913",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8071",
      "copilot-plugins": "/copilot-plugins/static-1.11025",
      "data-token-picker": "/data-token-picker/static-1.16351",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7842",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5351",
      "navigation-messaging": "/navigation-messaging/static-1.7261",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18415",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17533",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.605",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1038",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8745",
      "growth-data-modal": "/growth-data-modal/static-1.5379",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3038",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1831",
      "navigation-components": "/navigation-components/static-1.17934",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4753",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7506",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11009",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.854",
      "commerce-permissions": "/commerce-permissions/static-1.737",
      "products-iframe-lib": "/products-iframe-lib/static-1.7844",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10268",
      "data-agent-kit": "/data-agent-kit/static-1.144",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9969",
      "fsm": "/fsm/static-1.3702",
      "policy-lib": "/policy-lib/static-1.6747",
      "react-tinymce": "/react-tinymce/static-1.55149",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54275",
      "tinymce-plugins": "/tinymce-plugins/static-1.57389",
      "tinymce-themes": "/tinymce-themes/static-1.56245",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12154",
      "content-media-compositions": "/content-media-compositions/static-2.16161",
      "idb-keyval": "/idb-keyval/static-1.43",
      "media-bridge-lib": "/media-bridge-lib/static-1.18871",
      "ui-addon-opt": "/ui-addon-opt/static-4.8341",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6033",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5054",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3610",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19254",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8615",
      "purchase-motions-api": "/purchase-motions-api/static-1.5828",
      "trials-service-types": "/trials-service-types/static-1.3874",
      "reactive-lib": "/reactive-lib/static-1.693",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37075",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39438",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11927",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54618",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21383",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17721",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71896",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8719",
      "utility-belt": "/utility-belt/static-1.2508",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22668",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7447",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5661",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14725",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5080",
      "qrcode-generator": "/qrcode-generator/static-1.68",
      "deal-intel-utils": "/deal-intel-utils/static-1.1882",
      "storybook-react": "/storybook-react/static-1.32",
      "reporting-client-types": "/reporting-client-types/static-1.2488",
      "react-flip-move": "/react-flip-move/static-1.69",
      "FireAlarmUi": "/FireAlarmUi/static-1.4487",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4143",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10981",
      "association-settings-lib": "/association-settings-lib/static-1.10190",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57704",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12384",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12498",
      "final-form": "/final-form/static-1.69",
      "html-to-image": "/html-to-image/static-1.53",
      "nudge-client-utils": "/nudge-client-utils/static-1.2499",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7062",
      "property-management-iframe": "/property-management-iframe/static-1.13038",
      "property-usages-lib": "/property-usages-lib/static-1.5398",
      "reactflow": "/reactflow/static-1.63",
      "simple-data-table": "/simple-data-table/static-1.2687",
      "used-in-list-lib": "/used-in-list-lib/static-1.6917",
      "visual-association": "/visual-association/static-1.5845",
      "highcharts": "/highcharts/static-8.103",
      "reporting-visualizations": "/reporting-visualizations/static-1.59478",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3899",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.143",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.260",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2575",
      "ContentData": "/ContentData/static-1.68343",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.947",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1898",
      "ai-rendering-library": "/ai-rendering-library/static-1.10017",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7835",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15132",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.487",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.657",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.376",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6823",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3949",
      "ui-tool-access": "/ui-tool-access/static-1.10121",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1908",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1859",
      "user-context-client": "/user-context-client/static-1.4583",
      "nest": "/nest/static-1.196",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35631",
      "sales-views-client-types": "/sales-views-client-types/static-1.4235",
      "trellis-story-utils": "/trellis-story-utils/static-1.4487",
      "hub-http-contrib": "/hub-http-contrib/static-1.3010",
      "interframe": "/interframe/static-3.4731",
      "tinymce-data": "/tinymce-data/static-1.40360",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5181",
      "codemirror": "/codemirror/static-5.94",
      "layout-dnd-components": "/layout-dnd-components/static-1.12383",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11358",
      "react-codemirror": "/react-codemirror/static-1.10596",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9036",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.39956",
      "zustand": "/zustand/static-1.74",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7013",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54634",
      "commerce-products-api": "/commerce-products-api/static-1.2239",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56692",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102574",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80617",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7648",
      "reporting-ui-components": "/reporting-ui-components/static-2.64673",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14886",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18136",
      "stripe-connect-js": "/stripe-connect-js/static-1.68",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9515",
      "nested-table": "/nested-table/static-1.196",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21133",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2501",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5850",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4226",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2256",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2575",
      "whisper-core-api": "/whisper-core-api/static-1.6530",
      "property-management-common": "/property-management-common/static-1.5326",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15082",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12028",
      "ExportDialog": "/ExportDialog/static-6.10364",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33959",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.14241",
      "highlight.js": "/highlight.js/static-1.78",
      "reporting-action-components": "/reporting-action-components/static-1.41215",
      "reporting-snowflake": "/reporting-snowflake/static-1.56020",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9683",
      "browser-eslint": "/browser-eslint/static-2.57",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.495",
      "price-books-api": "/price-books-api/static-1.545",
      "price-books-components": "/price-books-components/static-1.603",
      "property-description-translator": "/property-description-translator/static-1.3817",
      "ramp-editor": "/ramp-editor/static-1.68",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3598",
      "totals-ui-components": "/totals-ui-components/static-1.23506",
      "reporting-plugins": "/reporting-plugins/static-1.10269",
      "reporting-reports": "/reporting-reports/static-1.67080",
      "edison-service-client-types": "/edison-service-client-types/static-1.358",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10481",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17010",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19603",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7967",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.144",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15081",
      "simple-menus-lib": "/simple-menus-lib/static-1.16598",
      "academy-common-lib": "/academy-common-lib/static-1.13701",
      "dashboard-lib": "/dashboard-lib/static-1.81388",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8672",
      "line-items-api": "/line-items-api/static-1.640",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3793",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.9001",
      "apps-service-types": "/apps-service-types/static-1.3848",
      "oauth-service-types": "/oauth-service-types/static-1.4221",
      "academy-service-client": "/academy-service-client/static-1.3653",
      "croppie": "/croppie/static-2.10",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7076",
      "redux-actions": "/redux-actions/static-3.7",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.510"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.29087",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};